
import { Question } from '../types';

export const qur101RevelationOrderQuestions: Question[] = [
  {
    id: 'qur051',
    text: 'What is the significance of Sūrat al-Fātiḥah in terms of its revelation timing?',
    type: 'single',
    options: [
      { id: 'a', text: 'It was revealed twice, once in each era (Makki and Madani)', isCorrect: true },
      { id: 'b', text: 'It was the very first complete surah to be revealed', isCorrect: false },
      { id: 'c', text: 'It was the final surah revealed before the Prophet\'s death', isCorrect: false },
      { id: 'd', text: 'It was revealed simultaneously in both Makkah and Madinah', isCorrect: false }
    ],
    explanation: 'Sūrat al-Fātiḥah was revealed twice, once in the Makki era and once in the Madani era. The second revelation served as a reminder of this foundational surah. This dual revelation contributes to differences of opinion regarding its classification.',
    topic: 'qur101'
  },
  {
    id: 'qur052',
    text: 'Why is there a difference of opinion about the classification of Sūrat ar-Raʿd?',
    type: 'single',
    options: [
      { id: 'a', text: 'It starts with Makki themes but transitions to Madani themes', isCorrect: true },
      { id: 'b', text: 'Half was revealed in Makkah and half in Madinah', isCorrect: false },
      { id: 'c', text: 'It was revealed to different companions in different locations', isCorrect: false },
      { id: 'd', text: 'Its manuscript was found in both cities', isCorrect: false }
    ],
    explanation: 'There is a difference of opinion about Sūrat ar-Raʿd because it starts with Makki themes and characteristics but transitions to Madani themes toward the end. This structural composition makes it difficult to classify definitively as either Makki or Madani.',
    topic: 'qur101'
  },
  {
    id: 'qur053',
    text: 'What is notable about the timing of Sūrat ar-Raḥmān\'s revelation?',
    type: 'single',
    options: [
      { id: 'a', text: 'It spans the very end of the Makki period and beginning of the Madani period', isCorrect: true },
      { id: 'b', text: 'It was revealed on a specific Islamic holiday', isCorrect: false },
      { id: 'c', text: 'It was the only surah revealed during a battle', isCorrect: false },
      { id: 'd', text: 'It was revealed simultaneously to multiple companions', isCorrect: false }
    ],
    explanation: 'Sūrat ar-Raḥmān is notable for spanning the very end of the Makki period and the beginning of the Madani period. This transitional timing contributes to the difficulty in definitively classifying it as either Makki or Madani.',
    topic: 'qur101'
  },
  {
    id: 'qur054',
    text: 'What explains the presence of "Oh people" (a typically Makki characteristic) in the Madani Sūrat al-Ḥujurāt (49:13)?',
    type: 'single',
    options: [
      { id: 'a', text: 'It was revealed in Makkah during the conquest but in the Madani period', isCorrect: true },
      { id: 'b', text: 'It was addressing both believers and non-believers', isCorrect: false },
      { id: 'c', text: 'It was a deliberate stylistic choice to emphasize universality', isCorrect: false },
      { id: 'd', text: 'It was originally Makki but moved to a Madani surah', isCorrect: false }
    ],
    explanation: 'The verse in Sūrat al-Ḥujurāt (49:13) beginning with "Oh people" (typically a Makki characteristic) is classified as Madani because of the era in which it was revealed, even though it was physically revealed in Makkah during the conquest. This shows that classification depends more on the time period than the physical location.',
    topic: 'qur101'
  },
  {
    id: 'qur055',
    text: 'What is the strongest evidence for Sūrat al-\'Alaq (verses 1-5) being the first revelation?',
    type: 'single',
    options: [
      { id: 'a', text: 'A strong hadith from Aisha RA describing the event in Ghar-i-Ḥirā\'', isCorrect: true },
      { id: 'b', text: 'The content of the verses themselves referring to creation', isCorrect: false },
      { id: 'c', text: 'Unanimous agreement among all scholars', isCorrect: false },
      { id: 'd', text: 'The short length typical of early revelations', isCorrect: false }
    ],
    explanation: 'The strongest evidence for Sūrat al-\'Alaq (verses 1-5) being the first revelation is a strong, authentic hadith from Aisha RA explicitly stating that these were the first five verses revealed to the Prophet ﷺ in Ghar-i-Ḥirā\' (Cave of Hira).',
    topic: 'qur101'
  },
  {
    id: 'qur056',
    text: 'What is the evidence for considering Sūrat al-Muddathir as an early revelation?',
    type: 'single',
    options: [
      { id: 'a', text: 'A hadith from Jabir ibn Abdillah about Jibrīl appearing to the Prophet ﷺ', isCorrect: true },
      { id: 'b', text: 'The shortness of its verses', isCorrect: false },
      { id: 'c', text: 'Its position in the Qur\'ān\'s compilation', isCorrect: false },
      { id: 'd', text: 'References to it in pre-Islamic poetry', isCorrect: false }
    ],
    explanation: 'The evidence for considering Sūrat al-Muddathir as an early revelation comes from a hadith narrated by Jabir ibn Abdillah, in which the Prophet ﷺ described how Jibrīl came to him in his true form and revealed these verses, after which the Prophet ﷺ went to Waraqa bin Naufal. This indicates these were the second set of verses revealed, though not the entire surah.',
    topic: 'qur101'
  },
  {
    id: 'qur057',
    text: 'What does "Muddathir" mean in the context of Sūrat al-Muddathir?',
    type: 'single',
    options: [
      { id: 'a', text: 'The one who is wrapped in garments/covering himself', isCorrect: true },
      { id: 'b', text: 'The one who warns', isCorrect: false },
      { id: 'c', text: 'The one who contemplates', isCorrect: false },
      { id: 'd', text: 'The one who recites', isCorrect: false }
    ],
    explanation: '"Muddathir" refers to "the one who is wrapped in garments" or "the one who covers himself." This title comes from the Prophet\'s ﷺ state after his overwhelming experience with Jibrīl, when he returned to Khadijah RA saying "Cover me, cover me" due to the intensity of the revelation experience.',
    topic: 'qur101'
  },
  {
    id: 'qur058',
    text: 'What is significant about Sūrat an-Naṣr in terms of timing?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'It was revealed near the end of the Prophet\'s ﷺ life', isCorrect: true },
      { id: 'b', text: 'Its content alludes to the approaching end of the Prophet\'s mission', isCorrect: true },
      { id: 'c', text: 'Some companions interpreted it as indicating the Prophet\'s passing', isCorrect: true },
      { id: 'd', text: 'It was revealed during the first pilgrimage', isCorrect: false }
    ],
    explanation: 'Sūrat an-Naṣr is significant in timing because it was revealed near the end of the Prophet\'s ﷺ life. Its content, which speaks about victory and people entering Islam in multitudes, was interpreted by some companions (like Umar ibn al-Khattab and \'Amr ibn al-\'Abbas) as alluding to the approaching completion of the Prophet\'s mission and his passing.',
    topic: 'qur101'
  },
  {
    id: 'qur059',
    text: 'Which verse is often cited as "the last verse regarding rulings" in the Qur\'ān?',
    type: 'single',
    options: [
      { id: 'a', text: 'Sūrat al-Mā\'idah verse 3 about the completion of the religion', isCorrect: true },
      { id: 'b', text: 'Sūrat al-Baqarah verse 281 about returning to Allāh', isCorrect: false },
      { id: 'c', text: 'The verses on riba (interest) in Sūrat al-Baqarah', isCorrect: false },
      { id: 'd', text: 'Sūrat an-Naṣr in its entirety', isCorrect: false }
    ],
    explanation: 'Sūrat al-Mā\'idah verse 3, which includes "This day I have perfected for you your religion and completed My favor upon you and have approved for you Islam as religion," is often cited as the last verse regarding rulings. It was revealed on the day of \'Arafah, approximately 87 nights before the Prophet\'s ﷺ passing.',
    topic: 'qur101'
  },
  {
    id: 'qur060',
    text: 'Which verse is considered by many scholars to be the absolutely final revelation of the Qur\'ān?',
    type: 'single',
    options: [
      { id: 'a', text: 'Sūrat al-Baqarah verse 281 about returning to Allāh', isCorrect: true },
      { id: 'b', text: 'Sūrat al-Mā\'idah verse 3 about completing the religion', isCorrect: false },
      { id: 'c', text: 'Sūrat an-Naṣr in its entirety', isCorrect: false },
      { id: 'd', text: 'The verses on riba (interest) in Sūrat al-Baqarah', isCorrect: false }
    ],
    explanation: 'Sūrat al-Baqarah verse 281, "And fear a Day when you will be returned to Allāh. Then every soul will be compensated for what it earned, and they will not be wronged," is considered by many scholars to be the absolutely final revelation of the Qur\'ān. This verse emphasizes accountability and divine justice as the final message.',
    topic: 'qur101'
  }
];
